import { cloneElement, type ReactElement } from 'react';

import { I, type IconProps } from '@/components/ri/icons';

export interface PWADisconnectedBannerProps {
  online: boolean;
  onRetry?: () => void;
}

export function PWADisconnectedBanner({ online, onRetry }: PWADisconnectedBannerProps) {
  if (online) return null;
  return (
    <div
      aria-live="polite"
      style={{
        position: 'fixed',
        left: 0,
        right: 0,
        top: 0,
        zIndex: 450,
        animation: 'ri-banner-slide-in .28s cubic-bezier(.2,.7,.3,1)',
        background: '#1C1917',
        color: '#FAFAF9',
        padding: '10px 14px',
        paddingTop: 'calc(10px + env(safe-area-inset-top, 0px))',
        display: 'flex',
        alignItems: 'center',
        gap: 10,
      }}
    >
      {cloneElement(I.wifiOff as ReactElement<IconProps>, { size: 16 })}
      <span style={{ flex: 1, fontSize: 13, fontWeight: 500 }}>
        You're offline · showing cached data
      </span>
      <button
        onClick={onRetry}
        style={{
          background: 'rgba(255,255,255,0.12)',
          border: 0,
          color: '#fff',
          fontSize: 12,
          padding: '4px 10px',
          borderRadius: 6,
          cursor: 'pointer',
        }}
      >
        Retry
      </button>
    </div>
  );
}
